import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom-v5-compat';
import { Center, Spinner } from 'src/components/atoms';
import {
  fetchReportingSession,
  getFetchReportingSessionLoading,
} from 'src/reducers/Reporting.slice';
import { AppDispatch } from 'src/store';
import { ReportingRoutingBackground } from '../ReportingRouting.styles';

export const ReportingRoute = () => {
  const dispatch = useDispatch<AppDispatch>();

  const fetchReportingSessionLoading = useSelector(
    getFetchReportingSessionLoading,
  );

  useEffect(() => {
    dispatch(fetchReportingSession());
  }, [dispatch]);

  if (fetchReportingSessionLoading) {
    return (
      <Center>
        <Spinner variant="secondary" size="xlarge" />
      </Center>
    );
  }

  return (
    <ReportingRoutingBackground>
      <Outlet />
      <style>{`
            .intercom-lightweight-app {
              visibility: hidden;
              pointer-events: none;
            }
          `}</style>
    </ReportingRoutingBackground>
  );
};
